import { render, staticRenderFns } from "./JsonMessage.vue?vue&type=template&id=72547c7e&scoped=true"
import script from "./JsonMessage.vue?vue&type=script&lang=js"
export * from "./JsonMessage.vue?vue&type=script&lang=js"
import style0 from "./JsonMessage.vue?vue&type=style&index=0&id=72547c7e&prod&lang=scss&scoped=true"
import style1 from "./JsonMessage.vue?vue&type=style&index=1&id=72547c7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72547c7e",
  null
  
)

export default component.exports